/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriceUnitType = {
    Country: 'Country',
    Lead: 'Lead'
} as const;
export type PriceUnitType = typeof PriceUnitType[keyof typeof PriceUnitType];


export function instanceOfPriceUnitType(value: any): boolean {
    for (const key in PriceUnitType) {
        if (Object.prototype.hasOwnProperty.call(PriceUnitType, key)) {
            if (PriceUnitType[key as keyof typeof PriceUnitType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriceUnitTypeFromJSON(json: any): PriceUnitType {
    return PriceUnitTypeFromJSONTyped(json, false);
}

export function PriceUnitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceUnitType {
    return json as PriceUnitType;
}

export function PriceUnitTypeToJSON(value?: PriceUnitType | null): any {
    return value as any;
}

export function PriceUnitTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PriceUnitType {
    return value as PriceUnitType;
}

